import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import DirectoryMessage from '../screens/EventDirectory/DirectoryMessage';
import EventDirectory from '../screens/EventDirectory/EventDirectory';
import EventDirectoryFilterScreen from '../screens/EventDirectory/EventDirectoryFilterScreen';
import { innerParticipantRoutes } from './participantsRoutes';
import { scheduleItemRoutes } from './scheduleRoutes';
import { SingleSpeakerRoutes } from './speakersRoutes';
import RelativeRedirect from '../elements/RelativeRedirect';

const directoryRoutes = (props) => {
    return (
        <Switch>
            <Route path={`${props.match.path}/program/:itemId`} component={scheduleItemRoutes} />
            <Route path={`${props.match.path}/speakers/:speakerId`} component={SingleSpeakerRoutes} />
            <Route path={`${props.match.path}/participants`} component={innerParticipantRoutes} />
            <Route path={`${props.match.path}/message`} exact component={DirectoryMessage} />
            <Route path={`${props.match.path}/filter`} exact component={EventDirectoryFilterScreen} />
            <Route path={`${props.match.path}`} exact component={EventDirectory} />
        </Switch>
    );
};

export default directoryRoutes;

export function childDirectoryRoutes(props) {
    return (
        <Switch>
            <RelativeRedirect from={`${props.match.path}`} to=".." exact />
            <Route path={`${props.match.path}/:path+`} component={directoryRoutes} />
        </Switch>
    );
}
